/* RJ45 cross-reference — searchable parts table + RFQ wiring. TeleWire Technology · 2026-10-03
   Loads xref-data.json (theme asset) once and renders the whole dataset as a filterable, sortable,
   paged table. Search matches manufacturer and TeleWire part numbers (punctuation-insensitive);
   several part numbers can be pasted at once (comma, semicolon or one per line).
   Every request button opens the site-wide RFQ pop-up (snippets/rfq-modal.liquid, data-rfq-open)
   with the part pre-filled; ticked rows collect in a request list that opens one RFQ for all.
   Without JavaScript the static, crawlable content (page.content) and its contact links still work. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mjx]');
  if (!root) return;
  var CTX = root.getAttribute('data-rfq-context') || 'RJ45 cross-reference';
  var PH = root.getAttribute('data-rfq-placeholder') || '';
  var SRC = root.getAttribute('data-src') || 'mj-xref-tool';
  var LOCK = root.getAttribute('data-brand-lock') || '';
  var PREFILL = 'Cross-reference request: ';

  function $(id) { return document.getElementById(id); }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function norm(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function slug(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function fmt(n) { return Number(n).toLocaleString('en-US'); }
  /* One contact URL per page (crawl hygiene 2026-10-08): the part number travels in data-rfq-part (rfq()), never in the URL,
     because Googlebot renders this table and followed one /pages/contact?part=… URL per row. */
  function contactHref() { return '/pages/contact?topic=crossref&src=' + SRC; }
  /* "Project details" text: model numbers only, comma-separated, e.g.
     "Request samples for these models: HFJ11-2450E, SI-60078-F". Every table button is
     "Request sample" (user decision 2026-10-03); engineering adds the drawing in the reply. */
  function reqMsg(kind, models) {
    var many = models.length > 1;
    var what = many ? 'samples' : 'sample';
    return 'Request ' + what + ' for ' + (many ? 'these models: ' : 'this model: ') + models.join(', ');
  }
  function rfq(node, part, label, msg) {
    node.setAttribute('data-rfq-open', '');
    if (msg) node.setAttribute('data-mjx-msg', msg); else node.removeAttribute('data-mjx-msg');
    if (part) node.setAttribute('data-rfq-part', part); else node.removeAttribute('data-rfq-part');
    node.setAttribute('data-rfq-context', CTX + ' — ' + label);
    if (PH) node.setAttribute('data-rfq-placeholder', PH);
  }

  /* Write "Project details" before the pop-up opens (this runs before its listener, which only
     fills an empty box). Anything the visitor typed is kept; an untouched pre-fill is replaced. */
  var lastFill = '';
  root.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-rfq-open]');
    if (!t) return;
    var m = $('rfq_message');
    if (!m) return;
    var v = m.value.trim();
    if (v && v !== lastFill && !(v.indexOf(PREFILL) === 0 && v.indexOf('\n') < 0)) return;
    lastFill = t.getAttribute('data-mjx-msg') || '';
    m.value = lastFill;
  });

  /* ---------- static content: give any bare table a horizontal scroller (narrow screens) ---------- */
  Array.prototype.forEach.call(root.querySelectorAll('.mjx-static table'), function (t) {
    if (!(t.parentNode.classList && t.parentNode.classList.contains('mjx-scroll'))) {
      var w = el('div', 'mjx-scroll'); t.parentNode.insertBefore(w, t); w.appendChild(t);
    }
    /* column names on each cell, so the table can become cards on phones */
    var heads = Array.prototype.map.call(t.querySelectorAll('thead th'), function (th) { return th.textContent.trim(); });
    Array.prototype.forEach.call(t.querySelectorAll('tbody tr'), function (tr) {
      Array.prototype.forEach.call(tr.cells, function (td, i) { if (heads[i] && !td.hasAttribute('data-label')) td.setAttribute('data-label', heads[i]); });
    });
  });

  /* ---------- series cards whose links were stripped by the page editor: rebuild them from the card text ---------- */
  Array.prototype.forEach.call(root.querySelectorAll('.mjx-static li > a:not([href])'), function (a) {
    var t = a.textContent.replace(/\s+/g, ' ').trim(), m;
    if ((m = t.match(/^Other (.+?) series\?/))) {
      a.setAttribute('href', '/pages/contact?topic=crossref-series&src=' + SRC + '-series');
      a.setAttribute('data-mjx-q', 'part=' + encodeURIComponent(m[1] + ' (other series)'));
    } else if ((m = t.match(/^(\S+) series\b/))) {
      a.setAttribute('href', '?q=' + encodeURIComponent(m[1]) + '#xref');
    }
  });

  /* ---------- static, crawlable request links → RFQ pop-up ---------- */
  Array.prototype.forEach.call(root.querySelectorAll('.mjx-static a[href*="/pages/contact"]'), function (a) {
    /* model = the row's "Part number" cell (column position differs between tables); a list link is the model */
    var part = '', tr = a.closest('tr'), pn = tr && tr.querySelector('td[data-label="Part number"]');
    var model = pn ? pn.textContent.trim() : (tr ? '' : a.textContent.trim());
    /* the part is in data-mjx-q (sections rewrite the content links); old-style links still carry it in the URL */
    try { part = new URLSearchParams(a.getAttribute('data-mjx-q') || '').get('part') || new URL(a.href, location.origin).searchParams.get('part') || ''; } catch (e) {}
    model = model || part;
    var topic = '';
    try { topic = new URL(a.href, location.origin).searchParams.get('topic') || ''; } catch (e) {}
    if (topic === 'crossref-series') {                 /* "Other [brand] series?" card */
      rfq(a, part, 'Other series: ' + part, 'Request a cross-reference for other ' + part.replace(/\s*\(other series\)$/, '') +
          ' series. Part numbers: ');
      return;
    }
    if (part) rfq(a, model, a.textContent.trim() + ': ' + part, reqMsg('sample', [model]));
  });

  /* ---------- numbers count up from 0 the first time they scroll into view ----------
     [data-mjx-count]: server-rendered number (tool title block) — animated from its own text.
     [data-mjx-stat]:  brand-page stats, filled in from xref-data.json once it loads (see brandStats). */
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function countUp(n, end, final, onStep) {
    if (still || !window.requestAnimationFrame) { n.textContent = final; if (onStep) onStep(1); return; }
    var t0 = null, D = 1600;
    (function step(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / D), e = 1 - Math.pow(1 - p, 3);   /* ease-out */
      n.textContent = fmt(Math.round(end * e));
      if (onStep) onStep(e);
      if (p < 1) requestAnimationFrame(step); else n.textContent = final;
    })(performance.now());
  }
  var watchers = [];                                   /* keep observers referenced so they are not collected */
  function whenVisible(n, fn) {
    var r = n.getBoundingClientRect();
    if (!('IntersectionObserver' in window) || (r.bottom > 0 && r.top < (window.innerHeight || 800))) return fn();
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); fn(); } });
    }, { threshold: 0.4 });
    watchers.push(io);
    io.observe(n);
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-mjx-count]'), function (n) {
    var final = n.textContent.trim(), end = parseInt(final.replace(/[^0-9]/g, ''), 10);
    if (!end || still) return;                         /* text, not a number: leave it */
    n.setAttribute('aria-label', final); n.textContent = '0';
    whenVisible(n, function () { countUp(n, end, final); });
  });
  /* brand page: parts / in catalogue / on request / coverage for the locked brand */
  function brandStats() {
    var stats = root.querySelectorAll('[data-mjx-stat]');
    if (!stats.length || !LOCK) return;
    var all = {}, cat = {};
    data.forEach(function (r) { if (r.bslug === LOCK) { all[r.model] = 1; if (r.tier === 'A') cat[r.model] = 1; } });
    var total = Object.keys(all).length, a = Object.keys(cat).length;
    var v = { total: total, catalogue: a, request: total - a };
    Array.prototype.forEach.call(stats, function (n) {
      var k = n.getAttribute('data-mjx-stat'), end = v[k] || 0;
      whenVisible(n, function () { countUp(n, end, fmt(end)); });
    });
    /* the ring next to the 4th stat is a gauge: it sweeps to full when it scrolls into view */
    var ring = root.querySelector('[data-mjx-ring]'), C = 2 * Math.PI * 28;
    if (ring) whenVisible(ring, function () {
      if (still || !window.requestAnimationFrame) { ring.style.strokeDashoffset = '0'; return; }
      var t0 = null;
      (function step(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / 1600);
        ring.style.strokeDashoffset = String(C * Math.pow(1 - p, 3));
        if (p < 1) requestAnimationFrame(step);
      })(performance.now());
    });
  }

  var q = $('mjx-q');
  var body = $('mjx-tbody');
  if (!q || !body) return;

  /* ---------- facets ---------- */
  var SPEED = [['100', '10/100 Mb/s'], ['1G', '1 Gb/s'], ['2.5G', '2.5 Gb/s'], ['5G', '5 Gb/s'], ['10G', '10 Gb/s']];
  var POE = [['No', 'No PoE'], ['PoE', 'PoE (802.3af)'], ['PoE+', 'PoE+ (802.3at)'], ['PoE++', 'PoE++ (802.3bt)']];
  var ORIENT = [['90', 'Right-angle (90°)'], ['180', 'Vertical (180°)']];
  var PORT_ORDER = ['1x1', '1x2', '1x4', '1x6', '1x8', '2x1', '2x2', '2x4', '2x6', '2x8', 'USB'];
  function speedOf(s) {
    s = String(s || '').toLowerCase().replace(/\s/g, '');
    if (!s) return '';
    if (s.indexOf('10g') >= 0) return '10G';
    if (/(^|[^.\d])5g/.test(s)) return '5G';          /* "5G", "2.5G/5G" — not the 5 in "2.5G" */
    if (s.indexOf('2.5g') >= 0) return '2.5G';
    if (s.indexOf('1000') >= 0) return '1G';
    return '100';
  }
  function portsOf(p) { p = String(p || ''); return /usb/i.test(p) ? 'USB' : p.toLowerCase(); }
  function portsLabel(p) {
    var u = String(p || '').toUpperCase();
    if (u === 'SINGLE PORT WITH SINGLE USB') return '1x1 + USB';
    if (u === 'SINGLE PORT WITH DUAL USB') return '1x1 + 2× USB';
    if (u === 'RJ45/USB') return 'RJ45 + USB';
    return p;
  }
  function orientOf(m) { m = String(m || ''); return m.indexOf('180') >= 0 ? '180' : m.indexOf('90') >= 0 ? '90' : ''; }

  /* ---------- elements ---------- */
  var sel = { brand: $('mjx-f-brand'), speed: $('mjx-f-speed'), poe: $('mjx-f-poe'), ports: $('mjx-f-ports'), orient: $('mjx-f-orient') };
  var status = $('mjx-status'), pager = $('mjx-pager'), perSel = $('mjx-per'), nomatch = $('mjx-nomatch'), nomatchBtn = $('mjx-nomatch-btn');
  var nomatchTerm = $('mjx-nomatch-term'), reset = $('mjx-reset'), clearQ = $('mjx-clear');
  var tray = $('mjx-tray'), trayCount = $('mjx-tray-count'), trayList = $('mjx-tray-list'), trayBtn = $('mjx-tray-btn'), trayClear = $('mjx-tray-clear');
  var thead = root.querySelectorAll('[data-sort]');

  /* ---------- filter dropdowns: a styled list that looks the same in every browser and theme.
     The <select> stays (hidden) as the source of truth, so URL state, reset and the manufacturer
     index keep working; choosing an option sets it and fires its change event. ---------- */
  var dds = [];
  function dropdown(select) {
    var box = el('div', 'mjx-dd');
    select.parentNode.insertBefore(box, select); box.appendChild(select);
    select.classList.add('mjx-dd__native'); select.tabIndex = -1; select.setAttribute('aria-hidden', 'true');
    var btn = el('button', 'mjx-dd__btn'), txt = el('span'), list = el('ul', 'mjx-dd__list'), active = -1;
    btn.type = 'button'; btn.id = select.id + '-btn'; btn.appendChild(txt);
    btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    list.id = select.id + '-list'; list.setAttribute('role', 'listbox'); list.hidden = true;
    btn.setAttribute('aria-controls', list.id);
    var lab = root.querySelector('label[for="' + select.id + '"]');
    if (lab) { lab.htmlFor = btn.id; lab.id = select.id + '-lbl'; list.setAttribute('aria-labelledby', lab.id); }
    box.appendChild(btn); box.appendChild(list);
    function sync() {
      var o = select.options[select.selectedIndex];
      txt.textContent = o ? o.text.replace(/\s*\([\d,]+\)$/, '') : '';
      box.classList.toggle('is-set', !!select.value);
    }
    function build() {
      list.textContent = '';
      Array.prototype.forEach.call(select.options, function (o, i) {
        var li = el('li', 'mjx-dd__opt'), m = o.text.match(/^(.*?)\s*\(([\d,]+)\)$/);
        li.id = list.id + '-' + i; li.setAttribute('role', 'option'); li.setAttribute('aria-selected', o.selected ? 'true' : 'false');
        li.appendChild(el('span', '', m ? m[1] : o.text));
        if (m) li.appendChild(el('small', '', m[2]));
        li.addEventListener('mousedown', function (e) { e.preventDefault(); });
        li.addEventListener('click', function () { choose(i); });
        list.appendChild(li);
      });
    }
    function setActive(i) {
      var items = list.children; if (!items.length) return;
      i = Math.max(0, Math.min(items.length - 1, i));
      if (items[active]) items[active].classList.remove('is-active');
      active = i; items[i].classList.add('is-active');
      btn.setAttribute('aria-activedescendant', items[i].id);
      items[i].scrollIntoView({ block: 'nearest' });
    }
    function open() { closeAll(box); build(); list.hidden = false; btn.setAttribute('aria-expanded', 'true'); setActive(select.selectedIndex); }
    function close() { list.hidden = true; btn.setAttribute('aria-expanded', 'false'); btn.removeAttribute('aria-activedescendant'); }
    function choose(i) {
      if (select.selectedIndex !== i) { select.selectedIndex = i; select.dispatchEvent(new Event('change')); }
      sync(); close(); btn.focus();
    }
    btn.addEventListener('click', function () { if (list.hidden) open(); else close(); });
    btn.addEventListener('keydown', function (e) {
      var k = e.key;
      if (list.hidden) { if (k === 'ArrowDown' || k === 'ArrowUp' || k === 'Enter' || k === ' ') { e.preventDefault(); open(); } return; }
      if (k === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (k === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (k === 'Home') { e.preventDefault(); setActive(0); }
      else if (k === 'End') { e.preventDefault(); setActive(list.children.length - 1); }
      else if (k === 'Enter' || k === ' ') { e.preventDefault(); choose(active); }
      else if (k === 'Escape') { e.preventDefault(); close(); }
      else if (k === 'Tab') close();
    });
    var api = { box: box, close: close, sync: sync };
    dds.push(api); sync();
    return api;
  }
  function closeAll(except) { dds.forEach(function (d) { if (d.box !== except) d.close(); }); }
  function syncDropdowns() { dds.forEach(function (d) { d.sync(); }); }
  document.addEventListener('click', function (e) { if (!e.target.closest || !e.target.closest('.mjx-dd')) closeAll(null); });
  Object.keys(sel).forEach(function (k) { if (sel[k]) dropdown(sel[k]); });

  var data = null, brandRank = {}, brands = [];
  var st = { q: '', brand: LOCK, speed: '', poe: '', ports: '', orient: '', sort: '', dir: 1, page: 1, per: parseInt(root.getAttribute('data-per') || '25', 10) };
  var hits = [], picked = {}, pickedOrder = [], MAX_PICK = 30, misses = [], gaTimer = null;

  function msgRow(text) {
    body.textContent = '';
    var tr = el('tr', 'mjx-msg'), td = el('td', '', text);
    td.colSpan = 10; tr.appendChild(td); body.appendChild(tr);
  }

  /* Brand pages: the complete cross-reference table in the page content (server HTML, crawlable) is the data
     source. It is read once, removed, and every row is rendered inside the search table (rows outside the current
     page are only hidden), so crawlers that skip JavaScript read the HTML table and Google's rendered page still
     contains every row — in one table, not two. */
  var ALL_ROWS = false;
  function fromPageTable() {
    if (!LOCK) return null;
    var best = null;
    Array.prototype.forEach.call(root.querySelectorAll('.mjx-static table'), function (t) {
      if (t.tBodies[0] && (!best || t.tBodies[0].rows.length > best.tBodies[0].rows.length)) best = t;
    });
    if (!best || best.tBodies[0].rows.length < 20) return null;
    var heads = Array.prototype.map.call(best.querySelectorAll('thead th'), function (th) { return th.textContent.trim().toLowerCase(); });
    function col(name) { for (var i = 0; i < heads.length; i++) if (heads[i].indexOf(name) >= 0) return i; return -1; }
    var c = { pn: col('part number'), tw: col('telewire'), ports: col('ports'), speed: col('speed'), poe: col('poe'), mount: col('mount'), shield: col('shield') };
    if (c.pn < 0 || c.tw < 0) return null;
    function txt(tr, i) { var v = i >= 0 && tr.cells[i] ? tr.cells[i].textContent.trim() : ''; return v === '–' ? '' : v; }
    if (!best.querySelector('a[href*="/products/"]')) {   /* content pasted without links: use xref-data.json instead */
      if (window.console) console.warn('RJ45 cross-reference: the page table has no product links — re-paste the content in HTML view');
      return null;
    }
    var rows = Array.prototype.map.call(best.tBodies[0].rows, function (tr) {
      var cell = tr.cells[c.tw], a = cell && cell.querySelector('a[href*="/products/"]'), tier = 'C', tw = '', handle = '';
      if (a) { tier = 'A'; tw = a.textContent.trim(); handle = a.getAttribute('href').split('/products/')[1].split(/[?#]/)[0]; }
      else { var m = (cell ? cell.textContent.trim() : '').match(/^(\S+)\s*\(not listed online\)/); if (m) { tier = 'B'; tw = m[1]; } }
      return [tier, 0, txt(tr, c.pn), tw, handle, txt(tr, c.ports), txt(tr, c.speed), txt(tr, c.poe), txt(tr, c.mount), txt(tr, c.shield)];
    });
    /* remove the duplicate: the table and the heading + intro paragraph written just above it */
    var box = best.closest('.mjx-scroll') || best, prev = box.previousElementSibling;
    if (prev && prev.tagName === 'P') { var h = prev.previousElementSibling; prev.parentNode.removeChild(prev); prev = h; }
    if (prev && /^H[23]$/.test(prev.tagName)) prev.parentNode.removeChild(prev);
    box.parentNode.removeChild(box);
    return { brands: [root.getAttribute('data-brand-name') || LOCK], rows: rows };
  }

  function load() {
    var own = null;
    try { own = fromPageTable(); } catch (err) { own = null; }
    if (own) { ALL_ROWS = true; ingest(own); return; }
    msgRow('Loading the cross-reference…');
    fetch(root.getAttribute('data-url'), { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (txt) {
      if (!txt) throw new Error('xref-data.json is empty — re-upload it with Upload file');
      ingest(JSON.parse(txt));
    }).catch(function (err) {
      if (window.console) console.warn('RJ45 cross-reference:', err && err.message);
      msgRow('The search could not load. Use the popular cross-references below, or send us the part number.');
    });
  }

  function ingest(j) {
      brands = j.brands;
      var count = {};
      data = j.rows.map(function (r) {
        var b = j.brands[r[1]];
        count[b] = (count[b] || 0) + 1;
        /* v2 file: specs and handles stored once, rows hold indexes; v1 rows hold the strings */
        var V = j.vocab, x = V
          ? { handle: j.handles[r[3]] || '', ports: V.ports[r[4]], speed: V.speed[r[5]], poe: V.poe[r[6]], mount: V.mount[r[7]], shield: V.shield[r[8]] }
          : { handle: r[4], ports: r[5], speed: r[6], poe: r[7], mount: r[8], shield: r[9] };
        return { tier: r[0], brand: b, bslug: slug(b), model: r[2], tw: r[3], handle: x.handle, ports: x.ports, speed: x.speed, poe: x.poe, mount: x.mount, shield: x.shield,
                 k: norm(r[2]), kt: norm(r[3]), kb: norm(b), sp: speedOf(x.speed), po: portsOf(x.ports), or: orientOf(x.mount) };
      });
      /* default order: in-catalogue first, then brands interleaved (biggest first) so page 1 shows range */
      var order = Object.keys(count).sort(function (a, b) { return push(a) - push(b) || count[b] - count[a]; });
      function push(b) { return /^(LINK-PP|X Multiple|Other)$/i.test(b) ? 1 : 0; }
      order.forEach(function (b, i) { brandRank[b] = i; });
      var seq = {};
      data.slice().sort(function (a, b) { return a.model < b.model ? -1 : 1; }).forEach(function (r) {
        var key = r.tier + r.brand; seq[key] = (seq[key] || 0); r.seq = seq[key]++;
      });
      buildFilters(order, count);
      brandStats();
      readUrl();
      run(true);
  }

  function opt(select, value, label) { var o = el('option', '', label); o.value = value; select.appendChild(o); }
  function buildFilters(order, count) {
    if (sel.brand) {
      order.slice().sort(function (a, b) { return a.localeCompare(b); }).forEach(function (b) { opt(sel.brand, slug(b), b + ' (' + fmt(count[b]) + ')'); });
      if (LOCK) { sel.brand.value = LOCK; sel.brand.closest('.mjx-f').hidden = true; }
    }
    function counted(select, list, key) {
      if (!select) return;
      list.forEach(function (p) {
        var n = data.filter(function (r) { return r[key] === p[0]; }).length;
        if (n) opt(select, p[0], p[1] + ' (' + fmt(n) + ')');
      });
    }
    counted(sel.speed, SPEED, 'sp');
    counted(sel.poe, POE, 'poe');
    counted(sel.orient, ORIENT, 'or');
    counted(sel.ports, PORT_ORDER.map(function (p) { return [p, p === 'USB' ? 'RJ45 + USB' : p]; }), 'po');
  }

  /* ---------- search ---------- */
  function terms(raw) {
    var parts = raw.split(/[,;|\n\t]+/).map(function (s) { return s.trim(); }).filter(Boolean);
    return parts;
  }
  function score(r, t) {
    if (r.k === t || r.kt === t) return 0;
    if (r.k.indexOf(t) === 0 || (r.kt && r.kt.indexOf(t) === 0)) return 1;
    if (t.length >= 3 && (r.k.indexOf(t) > 0 || (r.kt && r.kt.indexOf(t) > 0))) return 2;
    if (t.length >= 3 && r.kb.indexOf(t) === 0) return 3;
    return -1;
  }
  function passFilters(r) {
    if (st.brand && r.bslug !== st.brand) return false;
    if (st.speed && r.sp !== st.speed) return false;
    if (st.poe && r.poe !== st.poe) return false;
    if (st.ports && r.po !== st.ports) return false;
    if (st.orient && r.or !== st.orient) return false;
    return true;
  }
  function search() {
    misses = [];
    var list = terms(st.q), single = list.length <= 1;
    var toks = list.map(norm).filter(function (t) { return t.length >= 2; });
    var out = [];
    function scan(tokens, track) {
      var found = {}, res = [];
      for (var i = 0; i < data.length; i++) {
        var r = data[i];
        if (!passFilters(r)) continue;
        if (!tokens.length) { r.sc = 9; res.push(r); continue; }
        var best = -1;
        for (var j = 0; j < tokens.length; j++) {
          var s = score(r, tokens[j]);
          if (s >= 0) { if (track) found[j] = true; if (best < 0 || s < best) best = s; }
        }
        if (best >= 0) { r.sc = best; res.push(r); }
      }
      if (track) tokens.forEach(function (t, j) { if (!found[j]) misses.push(list[j] || t); });
      return res;
    }
    out = scan(toks, !single);
    /* "HFJ11-2450E SI-60078-F" typed with spaces: retry word by word */
    if (!out.length && single && /\s/.test(st.q.trim())) {
      list = st.q.trim().split(/\s+/);
      toks = list.map(norm).filter(function (t) { return t.length >= 3; });
      if (toks.length > 1) out = scan(toks, true);
    }
    return out;
  }

  var CMP = {
    brand: function (a, b) { return a.brand.localeCompare(b.brand); },
    model: function (a, b) { return a.model.localeCompare(b.model); },
    tw: function (a, b) { return (a.tw ? 0 : 1) - (b.tw ? 0 : 1) || a.tw.localeCompare(b.tw); },
    ports: function (a, b) { return PORT_ORDER.indexOf(a.po) - PORT_ORDER.indexOf(b.po); },
    speed: function (a, b) { return idx(SPEED, a.sp) - idx(SPEED, b.sp); },
    poe: function (a, b) { return idx(POE, a.poe) - idx(POE, b.poe); },
    mount: function (a, b) { return a.mount.localeCompare(b.mount); },
    shield: function (a, b) { return a.shield.localeCompare(b.shield); }
  };
  function idx(list, v) { for (var i = 0; i < list.length; i++) if (list[i][0] === v) return i; return 99; }
  function relevance(a, b) {
    return a.sc - b.sc || (a.tier < b.tier ? -1 : a.tier > b.tier ? 1 : 0) || (st.q ? 0 : a.seq - b.seq) || brandRank[a.brand] - brandRank[b.brand] || a.model.localeCompare(b.model);
  }
  function sortHits() {
    var f = CMP[st.sort];
    hits.sort(function (a, b) { return f ? (f(a, b) * st.dir || relevance(a, b)) : relevance(a, b); });
  }

  /* ---------- render ---------- */
  function hl(text, tokens) {
    var frag = document.createDocumentFragment();
    if (!tokens.length || !text) { frag.appendChild(document.createTextNode(text || '')); return frag; }
    var map = [], n = '';
    for (var i = 0; i < text.length; i++) { var c = text[i].toUpperCase(); if (/[A-Z0-9]/.test(c)) { map.push(i); n += c; } }
    var p = -1, t = '';
    for (var j = 0; j < tokens.length && p < 0; j++) { if (tokens[j].length >= 2) { p = n.indexOf(tokens[j]); t = tokens[j]; } }
    if (p < 0) { frag.appendChild(document.createTextNode(text)); return frag; }
    var s = map[p], e = map[p + t.length - 1] + 1;
    frag.appendChild(document.createTextNode(text.slice(0, s)));
    frag.appendChild(el('mark', 'mjx-hl', text.slice(s, e)));
    frag.appendChild(document.createTextNode(text.slice(e)));
    return frag;
  }
  function key(r) { return r.brand + '|' + r.model; }
  function cell(tr, cls, label, content) {
    var td = el('td', cls); td.setAttribute('data-label', label);
    if (content == null || content === '') td.textContent = '–';
    else if (typeof content === 'string') td.textContent = content;
    else td.appendChild(content);
    tr.appendChild(td); return td;
  }
  function row(r, tokens) {
    var tr = el('tr', picked[key(r)] ? 'is-picked' : '');
    var pick = el('input', 'mjx-pick'); pick.type = 'checkbox'; pick.checked = !!picked[key(r)];
    pick.setAttribute('aria-label', 'Add ' + r.brand + ' ' + r.model + ' to the request list');
    pick.addEventListener('change', function () { toggle(r, pick.checked, tr); });
    cell(tr, 'mjx-c-pick', 'Add to list', pick);
    cell(tr, 'mjx-c-brand', 'Manufacturer', r.brand);
    cell(tr, 'mjx-c-pn', 'Part number', hl(r.model, tokens));
    var tw;
    if (r.tier === 'A' && r.handle) { tw = el('a'); tw.href = '/products/' + r.handle; tw.appendChild(hl(r.tw, tokens)); }
    else if (r.tw) { tw = el('b'); tw.appendChild(hl(r.tw, tokens)); }
    else tw = el('i', '', 'Drop-in equivalent');
    cell(tr, 'mjx-c-tw', 'TeleWire Technology equivalent', tw);
    cell(tr, 'mjx-c-spec', 'Ports', portsLabel(r.ports));
    cell(tr, 'mjx-c-spec', 'Speed', r.speed);
    cell(tr, 'mjx-c-spec', 'PoE', r.poe);
    cell(tr, 'mjx-c-spec', 'Mount', r.mount);
    cell(tr, 'mjx-c-spec', 'Shield', r.shield);
    var label = 'Request sample';
    var a = el('a', 'mjx-btn mjx-btn--sm mjx-btn--line', label);
    a.href = contactHref();
    rfq(a, r.model, label + ': ' + r.brand + ' ' + r.model, reqMsg('sample', [r.model]));
    cell(tr, 'mjx-c-act', '', a);
    return tr;
  }
  function render() {
    var pages = Math.max(1, Math.ceil(hits.length / st.per));
    if (st.page > pages) st.page = pages;
    var from = (st.page - 1) * st.per, list = ALL_ROWS ? hits : hits.slice(from, from + st.per);
    var tokens = terms(st.q).map(norm);
    if (tokens.length === 1 && /\s/.test(st.q.trim())) tokens = tokens.concat(st.q.trim().split(/\s+/).map(norm));
    body.textContent = '';
    var frag = document.createDocumentFragment();
    list.forEach(function (r, i) {
      var tr = row(r, tokens);
      if (ALL_ROWS && (i < from || i >= from + st.per)) tr.hidden = true;   /* in the page, just not on this page */
      frag.appendChild(tr);
    });
    body.appendChild(frag);

    status.textContent = '';
    if (hits.length) {
      status.appendChild(document.createTextNode('Showing '));
      status.appendChild(el('strong', '', fmt(from + 1) + '–' + fmt(Math.min(from + st.per, hits.length))));
      status.appendChild(document.createTextNode(' of ' + fmt(hits.length) + (hits.length === 1 ? ' result' : ' results')));
    } else status.textContent = '0 results';
    if (misses.length && hits.length) {
      var m = el('span', 'mjx-miss', ' · Not found: ');
      misses.slice(0, 6).forEach(function (t) { m.appendChild(el('code', '', t)); });
      var b = el('a', '', 'Request ' + (misses.length > 1 ? 'these' : 'it'));
      b.href = contactHref();
      rfq(b, misses.join(', '), 'Not found: ' + misses.join(', '), reqMsg('sample', misses));
      m.appendChild(b); status.appendChild(m);
    }

    nomatch.hidden = hits.length > 0;
    if (!hits.length) {
      var t = st.q.trim();
      nomatchTerm.textContent = t ? '“' + t + '”' : 'these filters';
      nomatchBtn.href = contactHref();
      rfq(nomatchBtn, t, 'No match: ' + (t || 'filters'), t ? reqMsg('sample', terms(t)) : '');
      msgRow(t ? 'No part number matches “' + t + '”' + (filtersOn() ? ' with these filters' : '') + '.' : 'No parts match these filters.');
    }

    pager.textContent = '';
    if (pages > 1) {
      [['«', 1, 'First page'], ['‹', st.page - 1, 'Previous page']].forEach(btn);
      pager.appendChild(el('span', '', 'Page ' + st.page + ' of ' + fmt(pages)));
      [['›', st.page + 1, 'Next page'], ['»', pages, 'Last page']].forEach(btn);
    }
    function btn(b) {
      var x = el('button', '', b[0]); x.type = 'button'; x.setAttribute('aria-label', b[2]);
      x.disabled = b[1] < 1 || b[1] > pages || b[1] === st.page;
      x.addEventListener('click', function () { st.page = b[1]; render(); root.querySelector('.mjx-gridsec').scrollIntoView({ block: 'start' }); });
      pager.appendChild(x);
    }
    Array.prototype.forEach.call(thead, function (th) {
      th.setAttribute('aria-sort', th.getAttribute('data-sort') === st.sort ? (st.dir > 0 ? 'ascending' : 'descending') : 'none');
    });
  }
  function filtersOn() { return !!((st.brand && !LOCK) || st.speed || st.poe || st.ports || st.orient); }

  function run(initial) {
    if (!data) return;
    hits = search(); sortHits(); render(); writeUrl();
    syncDropdowns();
    reset.hidden = !(filtersOn() || st.q || st.sort);
    if (!initial && norm(st.q).length >= 3) {
      clearTimeout(gaTimer);
      gaTimer = setTimeout(function () {
        if (window.gtag) try { gtag('event', 'crossref_search', { search_term: st.q.slice(0, 80), brand: st.brand, results: hits.length, src: SRC }); } catch (e) {}
      }, 1200);
    }
  }

  /* ---------- URL state (shareable searches; ?q= & ?brand= also used by links) ---------- */
  var KEYS = ['q', 'brand', 'speed', 'poe', 'ports', 'orient'];
  function readUrl() {
    var p = new URLSearchParams(location.search);
    KEYS.forEach(function (k) { var v = p.get(k); if (v && !(k === 'brand' && LOCK)) st[k] = k === 'brand' ? slug(v) : v; });
    q.value = st.q;
    for (var k in sel) if (sel[k]) { sel[k].value = st[k] || ''; if (sel[k].value !== (st[k] || '')) st[k] = ''; }
  }
  function writeUrl() {
    try {
      var u = new URL(location.href);
      KEYS.forEach(function (k) { if (st[k] && !(k === 'brand' && LOCK)) u.searchParams.set(k, st[k]); else u.searchParams.delete(k); });
      history.replaceState(null, '', u);
    } catch (e) {}
  }

  /* ---------- request list ---------- */
  function toggle(r, on, tr) {
    var k = key(r);
    if (on && !picked[k]) {
      if (pickedOrder.length >= MAX_PICK) {
        tr.querySelector('.mjx-pick').checked = false;
        trayList.textContent = 'The list holds ' + MAX_PICK + ' parts. Send it, or attach your full BOM in the form.';
        return;
      }
      picked[k] = r; pickedOrder.push(k);
    } else if (!on && picked[k]) { delete picked[k]; pickedOrder.splice(pickedOrder.indexOf(k), 1); }
    if (tr) tr.classList.toggle('is-picked', on);
    updateTray();
  }
  function updateTray() {
    var n = pickedOrder.length;
    tray.classList.toggle('is-on', n > 0);
    tray.setAttribute('aria-hidden', n ? 'false' : 'true');
    trayCount.textContent = n + (n === 1 ? ' part' : ' parts');
    var models = pickedOrder.map(function (k) { return picked[k].model; });
    trayList.textContent = models.join(' · ');
    trayBtn.href = contactHref();
    rfq(trayBtn, models.join(', '), 'Request list (' + n + (n === 1 ? ' part' : ' parts') + ')', reqMsg('sample', models));
  }
  trayClear.addEventListener('click', function () {
    picked = {}; pickedOrder = []; updateTray();
    Array.prototype.forEach.call(body.querySelectorAll('.mjx-pick'), function (c) { c.checked = false; c.closest('tr').classList.remove('is-picked'); });
  });

  /* ---------- controls ---------- */
  var typing = null;
  q.addEventListener('input', function () { clearTimeout(typing); typing = setTimeout(function () { st.q = q.value; st.page = 1; run(); }, 160); });
  q.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); clearTimeout(typing); st.q = q.value; st.page = 1; run(); } });
  /* a column pasted from a spreadsheet arrives as one line per part: keep the separators */
  q.addEventListener('paste', function (e) {
    var t = (e.clipboardData || window.clipboardData);
    t = t && t.getData('text');
    if (!t || !/[\r\n\t]/.test(t)) return;
    e.preventDefault();
    var clean = t.split(/[\r\n\t]+/).map(function (s) { return s.trim(); }).filter(Boolean).join(', ');
    var s = q.selectionStart || 0, en = q.selectionEnd || 0;
    q.value = q.value.slice(0, s) + clean + q.value.slice(en);
    st.q = q.value; st.page = 1; run();
  });
  clearQ.addEventListener('click', function () { q.value = ''; st.q = ''; st.page = 1; run(); q.focus(); });
  Object.keys(sel).forEach(function (k) {
    if (sel[k]) sel[k].addEventListener('change', function () { st[k] = sel[k].value; st.page = 1; run(); });
  });
  /* clear search, sort and every filter (the brand too unless the page is locked to one brand) */
  function clearFilters(all) {
    st.q = ''; q.value = ''; st.sort = ''; st.dir = 1; st.page = 1;
    ['speed', 'poe', 'ports', 'orient'].forEach(function (k) { st[k] = ''; if (sel[k]) sel[k].value = ''; });
    if (all && !LOCK) { st.brand = ''; if (sel.brand) sel.brand.value = ''; }
  }
  reset.addEventListener('click', function () { clearFilters(true); run(); });
  perSel.value = String(st.per);
  perSel.addEventListener('change', function () { st.per = parseInt(perSel.value, 10) || 25; st.page = 1; render(); });
  Array.prototype.forEach.call(thead, function (th) {
    var b = th.querySelector('button');
    b.addEventListener('click', function () {
      var k = th.getAttribute('data-sort');
      if (st.sort !== k) { st.sort = k; st.dir = 1; } else if (st.dir > 0) st.dir = -1; else { st.sort = ''; st.dir = 1; }
      st.page = 1; sortHits(); render();
    });
  });
  Array.prototype.forEach.call(root.querySelectorAll('[data-mjx-example]'), function (b) {
    b.addEventListener('click', function () { clearFilters(true); q.value = b.textContent.trim(); st.q = q.value; run(); q.focus(); });
  });
  /* series links in the page content (href="?q=SI-60#xref") search the table in place */
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.mjx-static a[href*="?q="]');
    if (!a || !data) return;
    var v = '', u = null;
    try { u = new URL(a.href, location.href); v = u.searchParams.get('q') || ''; } catch (err) {}
    if (u && u.pathname !== location.pathname) return;  /* a link to another page: let it navigate */
    if (!v) return;
    e.preventDefault();
    clearFilters(true); q.value = v; st.q = v; run();
    $('xref').scrollIntoView({ block: 'start' });
  });
  /* manufacturer index: filter the table instead of reloading (brand pages keep their own link) */
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-mjx-brand]');
    if (!a || !data) return;
    e.preventDefault();
    clearFilters(true);                               /* other filters reset, or a pre-set PoE/speed could hide every row */
    st.brand = a.getAttribute('data-mjx-brand'); if (sel.brand) sel.brand.value = st.brand;
    run();
    $('xref').scrollIntoView({ block: 'start' });
  });

  if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 800 }); else setTimeout(load, 50);
})();
